import classnames from 'classnames';
import React from 'react';
import { useTranslations } from 'use-intl';

import Button from '@/components/button/Button';

import { Filter } from '@/types/filter/ActiveFilters.types';

import { withOpacity } from '@cineamo/ui/src/helpers/color-helper';

import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

type FilterGroupProps = {
    classNameFilterItem?: string;
    label?: string;
    filters: Filter[];
    onFilterClick: (filter: Filter) => void;
};

const FilterGroup: React.FC<FilterGroupProps> = ({ classNameFilterItem, label, filters, onFilterClick }) => {
    const t = useTranslations();
    const domainConfiguration = useDomainConfiguration();
    return (
        <div className="flex flex-col space-y-8">
            {label && <span className="text-body-bold-12">{label}</span>}
            <div className="flex flex-wrap gap-[6px] overflow-auto">
                {filters.map((filter) => {
                    const name =
                        typeof filter.name === 'string' && t.has(filter.name) ? t(filter.name.toString()) : filter.name;
                    return (
                        <Button
                            key={`FilterButton#${name}`}
                            className={classnames(classNameFilterItem, '!px-8 !py-0 normal-case')}
                            labelClassName="text-body-bold-12"
                            css={{
                                backgroundColor: filter.isActive
                                    ? domainConfiguration.style.primaryColor
                                    : withOpacity(domainConfiguration.style.onSurfaceColor, 0.2),
                                color: filter.isActive
                                    ? domainConfiguration.style.onPrimaryColor
                                    : domainConfiguration.style.onSurfaceColor
                            }}
                            onClick={() => onFilterClick?.(filter)}>
                            {name}
                        </Button>
                    );
                })}
            </div>
        </div>
    );
};

export default FilterGroup;
